import { isCanlan } from '../../../../utils/customer-name'

export type EntityIdKind =
  | 'organization'
  | 'competition'
  | 'team'
  | 'salesforce'

/**
 * Tenant-aware label for an entity's public UID, matching the legacy Setup
 * tab's `EditEntitySubTitle`: Canlan renames both the prefix and the org /
 * competition nouns ("Canlan League ID" vs "SN Organization ID").
 *
 * `salesforce` is the exception — it is the id from Canlan's own legacy
 * Salesforce system, not one we mint, so it carries neither prefix.
 */
export const entityIdLabel = (kind: EntityIdKind): string => {
  if (kind === 'salesforce') {
    return 'Salesforce ID'
  }

  const noun =
    kind === 'organization'
      ? isCanlan
        ? 'League'
        : 'Organization'
      : kind === 'competition'
      ? isCanlan
        ? 'Season'
        : 'Competition'
      : 'Team'

  return `${isCanlan ? 'Canlan' : 'SN'} ${noun} ID`
}
